import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-video-large.tsx
/**
* icon.24.video.large
*
* Keywords: play, media, triangle, right, start, rounded-square, control, frame
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3Ljc1NiA0LjAxM0EyLjUgMi41IDAgMCAxIDIwIDYuNXYxMWwtLjAxMy4yNTZBMi41IDIuNSAwIDAgMSAxNy41IDIwaC0xMUEyLjUgMi41IDAgMCAxIDQgMTcuNXYtMTFhMi41IDIuNSAwIDAgMSAyLjI0NC0yLjQ4N0w2LjUgNGgxMXpNNi41IDVBMS41IDEuNSAwIDAgMCA1IDYuNXYxMUExLjUgMS41IDAgMCAwIDYuNSAxOWgxMWExLjUgMS41IDAgMCAwIDEuNS0xLjV2LTExQTEuNSAxLjUgMCAwIDAgMTcuNSA1em0zLjAwNyAzLjEzYTEgMSAwIDAgMSAxLjAwOC4wMTNsNSAzYTEgMSAwIDAgMSAwIDEuNzE0bC01IDNBMS4wMDEgMS4wMDEgMCAwIDEgOSAxNVY5YTEgMSAwIDAgMSAuNTA3LS44N00xMCAxNWw1LTMtNS0zeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=23843-54446
*/
const Icon24VideoLarge = memo(function Icon24VideoLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.756 4.013A2.5 2.5 0 0 1 20 6.5v11l-.013.256A2.5 2.5 0 0 1 17.5 20h-11A2.5 2.5 0 0 1 4 17.5v-11a2.5 2.5 0 0 1 2.244-2.487L6.5 4h11zM6.5 5A1.5 1.5 0 0 0 5 6.5v11A1.5 1.5 0 0 0 6.5 19h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 17.5 5zm3.007 3.13a1 1 0 0 1 1.008.013l5 3a1 1 0 0 1 0 1.714l-5 3A1.001 1.001 0 0 1 9 15V9a1 1 0 0 1 .507-.87M10 15l5-3-5-3z"
		})
	});
});
//#endregion
export { Icon24VideoLarge };

//# sourceMappingURL=icon-24-video-large.js.map